"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesTPSLStore = exports.TPSLScene = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const TPSLUtils_1 = require("./TPSLUtils");
const CloseSetting_1 = require("./CloseSetting");
const const_1 = require("./../../../../component/const");
var TPSLScene;
(function (TPSLScene) {
    TPSLScene["Position"] = "Position";
    TPSLScene["TradeLimit"] = "TradeLimit";
    TPSLScene["TradeMarket"] = "TradeMarket";
    TPSLScene["TradeTrigger"] = "TradeTrigger";
})(TPSLScene = exports.TPSLScene || (exports.TPSLScene = {}));
/**使用该函数用来格式化价格，避免价格被显示成科学计数法 */
function formatPrice(price) {
    return price ? new trade_utils_lib_1.SafeDecimal(price).toFixed() : "";
}
/**设置止盈止损hooks */
function useFuturesTPSLStore(props) {
    const { trigger_price, trigger_price_type, trigger_limit_price, latestPrice: oLatestPrice, limitPrice, mode, precision = 0, position_side, maint_price, markPrice, provideEstPnlWithTriggerPrice, providePercentWithTriggerPrice, provideTriggerPriceWithPercent, provideTriggerPriceWithPnl, provideTriggerPriceWithPricePercent, providePricePercentWithTriggerPrice, scenes, isOneWay = false, isPnlMode = false, isolateMode = false, closeMode, tradeQty, closeQty, currencyPrecision, avoidCompareLiqPrice, symbol, leverage, type, } = props;
    const TPSLConfig = (0, TPSLUtils_1.useFuturesTPSLConfig)(symbol);
    /**百分比 */
    const [pricePercent, setPricePercent] = (0, react_1.useState)(() => trigger_price ? providePricePercentWithTriggerPrice(trigger_price, mode) : 0);
    const [percent, setPercent] = (0, react_1.useState)(() => (trigger_price ? providePercentWithTriggerPrice(trigger_price, mode) : 0));
    const [sliderValue, setSliderValue] = (0, react_1.useState)(() => percent);
    const [percentText, setPercentText] = (0, react_1.useState)(() => new trade_utils_lib_1.SafeDecimal(percent).toFixed(2));
    const latestPrice = (0, react_1.useMemo)(() => formatPrice(oLatestPrice), [oLatestPrice]);
    // 使用toFixed，解决显示科学计数法的问题
    /**当前设置的触发价格，如果为按盈亏额盈亏率设置时，会自动计算触发价格 */
    const [triggerPrice, setTriggerPrice] = (0, react_1.useState)(formatPrice(trigger_price));
    const changeTriggerPrice = (0, react_1.useCallback)((price) => {
        setTriggerPrice(formatPrice(price));
    }, []);
    const [priceType, setPriceType] = (0, react_1.useState)(trigger_price_type !== null && trigger_price_type !== void 0 ? trigger_price_type : const_1.DEFAULT_BASE_PRICE_TYPE);
    /**预计收益 */
    const [estPnl, setEstPnl] = (0, react_1.useState)(() => (triggerPrice ? provideEstPnlWithTriggerPrice(triggerPrice, mode) : ""));
    /**缓存providePercentWithTriggerPrice方法 */
    const providePercentWithRef = (0, react_1.useRef)(providePercentWithTriggerPrice);
    providePercentWithRef.current = providePercentWithTriggerPrice;
    /**缓存provideEstPnlWithTriggerPrice方法 */
    const provideEstPnlWithTriggerPriceRef = (0, react_1.useRef)(provideEstPnlWithTriggerPrice);
    provideEstPnlWithTriggerPriceRef.current = provideEstPnlWithTriggerPrice;
    /**重置当前hooks的状态 */
    const resetParams = (0, react_1.useCallback)(() => {
        setPercent(0);
        setTriggerPrice("");
        setEstPnl("");
        setSliderValue(0);
        setPercentText("");
        setPricePercent(0);
    }, []);
    const updatePercentInner = (0, react_1.useCallback)((p, updateText = true) => {
        setPercent(p);
        setSliderValue(p);
        updateText && setPercentText(new trade_utils_lib_1.SafeDecimal(p).toFixed(2));
    }, []);
    const changePercent = (0, react_1.useCallback)((p, updateText = true) => {
        updatePercentInner(p, updateText);
        // 修改盈亏率滑动条的时候，也要同步修改价格的滑动条
        setPricePercent(new trade_utils_lib_1.SafeDecimal(p).div(leverage).toNumber());
        const newPrice = provideTriggerPriceWithPercent(p, mode);
        const tp = TPSLUtils_1.TPSLUtils.formatTriggerPrice(newPrice, precision);
        setTriggerPrice(tp);
        // 重新计算未实现盈亏
        const newPnl = provideEstPnlWithTriggerPrice(newPrice, mode);
        setEstPnl(TPSLUtils_1.TPSLUtils.formatPnl(newPnl, currencyPrecision));
    }, [currencyPrecision, leverage, mode, precision, provideEstPnlWithTriggerPrice, provideTriggerPriceWithPercent, updatePercentInner]);
    const changePricePercent = (0, react_1.useCallback)((p, updateText = true) => {
        setPricePercent(p);
        // 修改价格滑动条的时候，也要同步修改盈亏率的滑动条
        updatePercentInner(new trade_utils_lib_1.SafeDecimal(p).mul(leverage).toNumber(), updateText);
        const newPrice = provideTriggerPriceWithPricePercent(p, mode);
        const tp = TPSLUtils_1.TPSLUtils.formatTriggerPrice(newPrice, precision);
        setTriggerPrice(tp);
        // 重新计算未实现盈亏
        const newPnl = provideEstPnlWithTriggerPrice(newPrice, mode);
        setEstPnl(TPSLUtils_1.TPSLUtils.formatPnl(newPnl, currencyPrecision));
    }, [
        currencyPrecision,
        leverage,
        mode,
        precision,
        provideEstPnlWithTriggerPrice,
        provideTriggerPriceWithPricePercent,
        updatePercentInner,
    ]);
    /**修改百分比 */
    const changePercentText = (0, react_1.useCallback)((text) => {
        if (!text) {
            resetParams();
            return;
        }
        changePercent(new trade_utils_lib_1.SafeDecimal(text).toDP(2).toNumber(), false);
        setPercentText(text);
    }, [changePercent, resetParams]);
    const changeEstPnl = (0, react_1.useCallback)((newPnl) => {
        if (!newPnl) {
            resetParams();
            return;
        }
        const pnl = TPSLUtils_1.TPSLUtils.roundPnlFlagWithMode(newPnl, mode);
        setEstPnl(pnl);
        const price = provideTriggerPriceWithPnl(pnl);
        setTriggerPrice(TPSLUtils_1.TPSLUtils.formatTriggerPrice(price, precision));
        const newPercent = providePercentWithTriggerPrice(price, mode);
        updatePercentInner(newPercent);
        //修改盈亏额输入框时同步修改价格涨跌幅
        const newPricePercent = providePricePercentWithTriggerPrice(price, mode);
        setPricePercent(newPricePercent);
    }, [
        mode,
        precision,
        providePercentWithTriggerPrice,
        providePricePercentWithTriggerPrice,
        provideTriggerPriceWithPnl,
        resetParams,
        updatePercentInner,
    ]);
    // 按照盈亏额设置止盈止损，当修改平仓量时需要重新计算对应的价格以及百分比
    const onChangeCloseQty = (0, react_1.useCallback)(() => {
        if (!isPnlMode) {
            // 重新计算未实现盈亏
            if (triggerPrice) {
                const newPnl = provideEstPnlWithTriggerPriceRef.current(triggerPrice, mode);
                setEstPnl(TPSLUtils_1.TPSLUtils.formatPnl(newPnl, currencyPrecision));
            }
            else {
                setPercentText("");
            }
            return;
        }
        changeEstPnl(estPnl);
    }, [changeEstPnl, currencyPrecision, estPnl, isPnlMode, mode, triggerPrice]);
    // 是否比较预估强平价
    const compareLiquidPrice = avoidCompareLiqPrice ? false : isolateMode || (isOneWay && scenes === TPSLScene.Position);
    // 获取设置止盈止损时，部分平仓相关的参数
    const closeSetting = (0, CloseSetting_1.useTPSLCloseSetting)({
        closeMode,
        closeQty,
        tradeQty,
        scenes,
        onChangeCloseQty,
        trigger_limit_price,
        latestPrice,
        triggerPrice,
        mode,
        type,
        // 针对止盈止损的限价的校验逻辑，需要跟触发价格保持一致
        onValidateLimitPrice(price, estLiqPrice) {
            return TPSLUtils_1.TPSLUtils.checkTriggerPriceError({
                triggerPrice: price,
                curPrice: latestPrice,
                markPrice,
                priceType,
                scenes,
                side: position_side,
                mode,
                liqPrice: estLiqPrice || maint_price,
                compareLiquidPrice,
                limitPrice,
                limit: TPSLConfig === null || TPSLConfig === void 0 ? void 0 : TPSLConfig.offsetLimit,
                field: TPSLUtils_1.ErrorFiledName.OrderPriceField,
            });
        },
    });
    const { validateCloseSetting, checkUserModifiedCloseSetting, resetCloseSetting } = closeSetting;
    // 重置所有状态
    const resetAllParams = (0, react_1.useCallback)((resetCloseQty = true) => {
        resetParams();
        resetCloseQty && resetCloseSetting();
    }, [resetCloseSetting, resetParams]);
    /**检测用户是否修改过价格 */
    const checkUserModified = (0, react_1.useCallback)(() => {
        return (!new trade_utils_lib_1.SafeDecimal(trigger_price).eq(new trade_utils_lib_1.SafeDecimal(triggerPrice)) ||
            priceType !== trigger_price_type ||
            checkUserModifiedCloseSetting());
    }, [checkUserModifiedCloseSetting, priceType, triggerPrice, trigger_price, trigger_price_type]);
    const changePrice = (0, react_1.useCallback)((price) => {
        if (!price) {
            resetParams();
            return;
        }
        setTriggerPrice(price);
        const newPercent = providePercentWithTriggerPrice(price, mode);
        updatePercentInner(TPSLUtils_1.TPSLUtils.formatPercent(newPercent));
        const newPricePercent = providePricePercentWithTriggerPrice(price, mode);
        setPricePercent(TPSLUtils_1.TPSLUtils.formatPercent(newPricePercent));
        // 重新计算未实现盈亏
        const newPnl = provideEstPnlWithTriggerPrice(price, mode);
        setEstPnl(TPSLUtils_1.TPSLUtils.formatPnl(newPnl, currencyPrecision));
    }, [
        currencyPrecision,
        mode,
        provideEstPnlWithTriggerPrice,
        providePercentWithTriggerPrice,
        providePricePercentWithTriggerPrice,
        resetParams,
        updatePercentInner,
    ]);
    // 市价单设置止盈止损并且选择pnl模式，需要watch当前价格的变跟，实时更新触发价格跟百分比
    (0, react_1.useEffect)(() => {
        if (isPnlMode && !new trade_utils_lib_1.SafeDecimal(estPnl).eq(0) && scenes === TPSLScene.TradeMarket) {
            const price = provideTriggerPriceWithPnl(estPnl);
            setTriggerPrice(TPSLUtils_1.TPSLUtils.formatTriggerPrice(price, precision));
            const newPercent = providePercentWithTriggerPrice(price, mode);
            updatePercentInner(TPSLUtils_1.TPSLUtils.formatPercent(newPercent));
            // 更新价格涨跌幅
            const newPricePercent = providePricePercentWithTriggerPrice(price, mode);
            setPricePercent(TPSLUtils_1.TPSLUtils.formatPercent(newPricePercent));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPnlMode, latestPrice]);
    /**校验用户的输入是否合法 */
    const validateUserInput = (currentTriggerPrice, side, estLiqPrice) => TPSLUtils_1.TPSLUtils.checkTriggerPriceError({
        triggerPrice: currentTriggerPrice,
        curPrice: latestPrice,
        markPrice,
        priceType,
        scenes,
        side,
        mode,
        liqPrice: estLiqPrice || maint_price,
        compareLiquidPrice,
        limitPrice,
        limit: TPSLConfig === null || TPSLConfig === void 0 ? void 0 : TPSLConfig.offsetLimit,
    });
    // TODO: 当止损价 < 强平标记价格 * X%， 二次弹窗提醒
    // 是否展示止损价离强平价过近的提醒
    const showSlLiquidPriceWarning = (0, react_1.useCallback)((params) => {
        const { estLiqPrice, triggerPrice: _triggerPrice } = params || {};
        if (mode !== "sl" || !compareLiquidPrice)
            return false;
        // 触发价格
        const priceD = new trade_utils_lib_1.SafeDecimal(_triggerPrice || triggerPrice);
        // 强平价格 需要将价格中的千分位等非数字和小数点的字符删除
        const liqPriceD = new trade_utils_lib_1.SafeDecimal(`${estLiqPrice || maint_price}`.replace(/[^0-9.]/g, ""));
        // 强平价格小于等于0的情况，不触发弹窗
        if (liqPriceD.lessThanOrEqualTo(0)) {
            return false;
        }
        const limit = TPSLConfig === null || TPSLConfig === void 0 ? void 0 : TPSLConfig.warningOffsetLimit;
        if (!limit) {
            return false;
        }
        // 价差 = abs(触发价格 - 预估强平价)
        const spread = new trade_utils_lib_1.SafeDecimal(priceD).sub(liqPriceD).abs();
        return new trade_utils_lib_1.SafeDecimal(spread).div(liqPriceD).lessThanOrEqualTo(limit);
    }, [TPSLConfig === null || TPSLConfig === void 0 ? void 0 : TPSLConfig.warningOffsetLimit, compareLiquidPrice, maint_price, mode, triggerPrice]);
    /**对外暴露的校验函数 */
    const validateWithLiqPrice = (estLiqPrice) => validateUserInput(triggerPrice, position_side, estLiqPrice) || validateCloseSetting(estLiqPrice);
    // 计算预估盈亏
    const profitInfo = (() => {
        function getProfitValue() {
            const profit = isPnlMode ? new trade_utils_lib_1.SafeDecimal(estPnl) : new trade_utils_lib_1.SafeDecimal(provideEstPnlWithTriggerPrice(triggerPrice, mode));
            const isIncrease = profit.gte(0);
            return {
                profit: profit.toDP(currencyPrecision, decimal_js_1.default.ROUND_FLOOR).toString(),
                increase: isIncrease,
                percent: TPSLUtils_1.TPSLUtils.formatProfitPercent(percent, isIncrease, "1"),
                pricePercent: TPSLUtils_1.TPSLUtils.formatProfitPercent(pricePercent, isIncrease, leverage),
            };
        }
        const errorInfo = validateUserInput(triggerPrice, position_side);
        const closeSettingError = validateCloseSetting();
        // 只有平仓数量输入框相关的错误才认为是错误，订单价格的报错不影响预计盈亏的显示
        const withCloseError = closeSettingError && closeSettingError.field === TPSLUtils_1.ErrorFiledName.CloseQtyField;
        if (!errorInfo && !withCloseError) {
            const val = getProfitValue();
            return {
                data: val,
            };
        }
        return {
            error: errorInfo,
        };
    })();
    /**
     * 获取价格相关的提示
     * - closeToCurPrice 靠近当前价格
     * - closeToMarkPrice 靠近标记价格
     */
    const closeToPriceWarning = (0, react_1.useMemo)(() => {
        const minDiff = 0.002;
        const isLimitTradeScenes = scenes === TPSLScene.TradeLimit;
        const triggerPriceD = new trade_utils_lib_1.SafeDecimal(triggerPrice);
        const markPriceD = new trade_utils_lib_1.SafeDecimal(markPrice);
        const curPriceD = new trade_utils_lib_1.SafeDecimal(latestPrice);
        const triggerByMarkPrice = priceType === interface_1.TriggerPriceType.MARK_PRICE;
        // 参数非法，不需要给出提示
        if (triggerPriceD.lte(0) || (!isLimitTradeScenes && markPriceD.lte(0)) || curPriceD.lte(0)) {
            return undefined;
        }
        if (isLimitTradeScenes) {
            if (triggerPriceD.sub(curPriceD).div(curPriceD).abs().lte(minDiff)) {
                return "closeToCurPrice";
            }
        }
        else {
            if (scenes === TPSLScene.TradeMarket) {
                if (triggerPriceD.sub(markPriceD).div(markPrice).abs().lte(minDiff)) {
                    return "closeToMarkPrice";
                }
                if (triggerPriceD.sub(curPriceD).div(curPriceD).abs().lte(minDiff)) {
                    return "closeToCurPrice";
                }
            }
            else {
                if (triggerByMarkPrice) {
                    if (triggerPriceD.sub(markPriceD).div(markPrice).abs().lte(minDiff)) {
                        return "closeToMarkPrice";
                    }
                }
                else {
                    if (triggerPriceD.sub(curPriceD).div(curPriceD).abs().lte(minDiff)) {
                        return "closeToCurPrice";
                    }
                }
            }
        }
        return undefined;
    }, [latestPrice, markPrice, priceType, scenes, triggerPrice]);
    /**获取当前价格对应的百分比 */
    const latestPricePercent = (0, react_1.useMemo)(() => {
        return providePercentWithTriggerPrice(latestPrice, mode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latestPrice, providePercentWithTriggerPrice]);
    return Object.assign({ percent, setPercent: changePercent, triggerPrice, setTriggerPrice: changeTriggerPrice, setEstPnl: setEstPnl, priceType, setPriceType: setPriceType, checkUserModified,
        changePercent,
        changePrice,
        profitInfo,
        latestPricePercent, resetParams: resetAllParams, closeToPriceWarning,
        showSlLiquidPriceWarning, profit: estPnl, changeProfit: changeEstPnl, validateUserInput,
        validateWithLiqPrice,
        percentText,
        sliderValue, changeSidlerValue: changePercent, changePercentText,
        scenes,
        pricePercent,
        changePricePercent }, closeSetting);
}
exports.useFuturesTPSLStore = useFuturesTPSLStore;
